import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { API, BASE_API } from 'src/environments/environment';

interface DocumentoConsulta {
  tipo: string;
  path: string;
  nome?: string;
  descricao?: string;
}

interface DocumentoAberto {
  tipo: string;
  nome: string;
  url: string;
  abertoEm: Date;
}

@Component({
  selector: 'app-documentos-consulta',
  templateUrl: './documentos-consulta.component.html',
  styleUrls: ['./documentos-consulta.component.scss']
})
export class DocumentosConsultaComponent implements OnInit {
  idConsulta = '';
  loading = false;
  documentos: DocumentoConsulta[] = [];
  arquivosAbertos: DocumentoAberto[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ajaxService: AjaxService,
    private util: UtilService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.idConsulta = params.get('idConsulta') || '';
      this.carregarDocumentos();
    });
  }

  voltar(): void {
    this.router.navigate(['/consultar-atendimento']);
  }

  resolverUrlDocumento(path: string): string {
    const valor = String(path || '').trim();
    if (!valor) return '';
    if (valor.startsWith('http://') || valor.startsWith('https://')) return valor;
    return `${BASE_API}${valor.startsWith('/') ? '' : '/'}${valor}`;
  }

  resolverUrlDocumentoSegura(path: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.resolverUrlDocumento(path));
  }

  abrirDocumento(documento: DocumentoConsulta): void {
    const url = this.resolverUrlDocumento(documento.path);
    if (!url) {
      this.util.toasterShowError('Erro', 'Arquivo inválido para abertura.');
      return;
    }

    window.open(url, '_blank', 'noopener');

    this.arquivosAbertos.unshift({
      tipo: documento.tipo || 'Documento',
      nome: documento.nome || 'Sem nome',
      url,
      abertoEm: new Date()
    });
  }

  private carregarDocumentos(): void {
    if (!this.idConsulta) {
      this.documentos = [];
      return;
    }

    this.loading = true;
    this.util.showLoading();
    this.ajaxService
      .get(`${API}empresa/Consulta/VisualizarDocumentos?idConsulta=${encodeURIComponent(this.idConsulta)}`)
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.util.closeLoading();

          const lista = this.normalizarLista(response?.data);
          this.documentos = lista
            .map((item: any) => this.util.converterParaLowercase(item))
            .filter((item: any) => !!item?.path)
            .map((item: any) => ({
              tipo: item.tipo || 'Documento',
              path: item.path,
              nome: item.nome || '',
              descricao: item.descricao || ''
            }));
        },
        error: () => {
          this.loading = false;
          this.util.closeLoading();
          this.documentos = [];
          this.util.toasterShowError('Erro', 'Não foi possível carregar os documentos desta consulta.');
        }
      });
  }

  private normalizarLista(data: any): any[] {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (typeof data === 'object') return Object.values(data);
    return [];
  }
}
